import union from 'lodash/union';

import type { DataKey, DataLayer, Store } from './DataLayer';

export default (
  initialState: DataLayer,
  persistentKeys: DataKey[] = [],
): Store => {
  // Spreading the initial state will make sure it will create a new state
  let currentState = { ...initialState };
  let persistentOnceKeysSet = new Set<DataKey>();

  const getState: Store['getState'] = () => currentState;

  const update: Store['update'] = (newState, opts) => {
    opts?.keepKeysForNextPrune?.forEach((key) =>
      persistentOnceKeysSet.add(key),
    );

    Object.entries(newState).forEach((entry) => {
      const [key, value] = entry as [DataKey, any];
      currentState[key] = value;
    });

    // Native delete have higher precedence than Lodash omit()
    opts?.omitKeys?.forEach((key) => {
      delete currentState[key];
    });
  };

  const prune: Store['prune'] = () => {
    const keysToPersist = union(
      persistentKeys,
      Array.from(persistentOnceKeysSet),
    );

    // Native pick have higher precedence than Lodash pick()
    const newState = keysToPersist.reduce(
      (stateResult, key) => {
        stateResult[key] = currentState[key];
        return stateResult;
      },
      {} as Record<DataKey, any>,
    );

    currentState = newState;
    persistentOnceKeysSet = new Set();
  };

  return {
    getState,
    update,
    prune,
  };
};
